<script setup lang="ts">

import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import { useTransactionStore } from '@/modules/transaction/stores/transaction.list.store.ts'
import { useRouter } from 'vue-router'
import TransactionList from '@/modules/transaction/views/TransactionList.vue'

const router = useRouter()

const transactionListStore = useTransactionStore()


</script>

<template>
  <dashboard-layout currentRoute="transaction/history" page-title="Lịch sử giao dịch">
    <TransactionList/>
  </dashboard-layout>
</template>

<style scoped>

</style>
